export default __webpack_public_path__ + "static/media/nss-2.3c584ade.png";